module.exports = __webpack_public_path__ + "img/ind_coal.b0632922.png";